module.exports = __webpack_public_path__ + "static/img/eating.c284b4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eating.png
// module id = bNfQ
// module chunks = 1